import { render } from "./edit-pages.vue?vue&type=template&id=376b34df"
import script from "./edit-pages.vue?vue&type=script&lang=js"
export * from "./edit-pages.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__